const PREFIX = 'evie_draft';
// Use '::' as separator — readable in DevTools and not a valid character in
// real-world email addresses, RP slugs, or UUIDs.
const SEP = '::';

function draftKey(email: string, rpName: string, conversationId: string | null): string {
    return conversationId
        ? `${PREFIX}${SEP}${email}${SEP}${rpName}${SEP}${conversationId}`
        : `${PREFIX}${SEP}${email}${SEP}${rpName}`;
}

export function saveDraft(
    email: string,
    rpName: string,
    conversationId: string | null,
    text: string,
): void {
    if (!email || !rpName) {
        return;
    }
    const key = draftKey(email, rpName, conversationId);
    try {
        if (text) {
            window.localStorage.setItem(key, text);
        } else {
            window.localStorage.removeItem(key);
        }
    } catch {
        // localStorage may be unavailable in restricted environments
    }
}

export function loadDraft(
    email: string,
    rpName: string,
    conversationId: string | null,
): string {
    if (!email || !rpName) {
        return '';
    }
    const key = draftKey(email, rpName, conversationId);
    try {
        return window.localStorage.getItem(key) || '';
    } catch {
        return '';
    }
}

export function clearDraft(
    email: string,
    rpName: string,
    conversationId: string | null,
): void {
    if (!email || !rpName) {
        return;
    }
    const key = draftKey(email, rpName, conversationId);
    try {
        window.localStorage.removeItem(key);
    } catch {
        // localStorage may be unavailable in restricted environments
    }
}
